export default "__VITE_ASSET__0rD94NMfS1WHp0id2YoAeg__"